export default "__VITE_ASSET__b97154e2__"